export default "__VITE_ASSET__e5bbb675__"